if (document.querySelectorAll(".page-navigation")) {
  const main = document.querySelector<HTMLElement>("#main");

  // Get the sections with ids
  const sections = main?.querySelectorAll<HTMLElement>("*[id]");

  if (sections) {
    // Get the nav items corresponding to each section
    const sectionsToNavItems = new Map<HTMLElement, HTMLElement>();
    for (const section of sections) {
      const navItem = main?.querySelector<HTMLElement>(
        `.page-navigation__link[href="#${section.id}"]`
      );
      if (navItem != null) {
        sectionsToNavItems.set(section, navItem);
      }
    }

    // Update nav item classes based on scroll position
    const updateNavClasses = (): void => {
      function parseScrollPadding(value: string): number {
        if (value === "auto") return 0;
        return parseFloat(value);
      }

      // Get rect relative to scrollPaddingTop
      function relativeToscrollPaddingTop(rect: DOMRect): number {
        let pageNavigationHeight =
          document.querySelector<HTMLElement>(".page-navigation")?.offsetHeight;
        pageNavigationHeight = pageNavigationHeight ? pageNavigationHeight : 0;
        const documentStyle = getComputedStyle(document.documentElement);
        const scrollPaddingTop = parseScrollPadding(
          documentStyle.scrollPaddingTop
        );

        // Add a 5px leeway
        return Math.min(0, rect.top - scrollPaddingTop - 5);
      }

      // Find section with most screen relPos
      let best: [HTMLElement, number] | null = null;
      for (const section of sections) {
        const rect = section.getBoundingClientRect();
        const relPos = relativeToscrollPaddingTop(rect);

        if (best == null) {
          best = [section, relPos];
          continue;
        }

        if (relPos == 0) {
          // The section is below the target marker;
          // any succeeding ones will also be too low;
          // we're done
          break;
        }

        if (relPos >= best[1]) {
          best = [section, relPos];
        }
      }

      // Do nothing if no best item was found (this should never happen)
      if (best == null) return;

      // Update classes
      for (const section of sections) {
        sectionsToNavItems
          .get(section)
          ?.classList.toggle("active", section === best[0]);
      }
    };

    // Listen for scroll events
    window.addEventListener("scroll", updateNavClasses);

    // Set initial state
    updateNavClasses();
  }
}

// Calculate page navigation height css variable
function calcPageNavigationHeight(): void {
  const root = document.documentElement;
  const pageNavigationHeight =
    document.querySelector<HTMLElement>(".page-navigation")?.offsetHeight;

  if (pageNavigationHeight) {
    root.style.setProperty(
      "--page-navigation-height",
      pageNavigationHeight + "px"
    );
  }
}
calcPageNavigationHeight();
window.addEventListener("load", calcPageNavigationHeight);
window.addEventListener("resize", calcPageNavigationHeight, true);
